import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    gridQuiz: {
        display: 'grid',
        gap: 10,
        minHeight: '65%',
    },
    wrapperItem: {
        textAlign: 'center',
        padding: '10px',
        height: `100%`,
        position: 'relative',
        width: '100%',
        marginBottom: '2px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    boxItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 8,
        position: 'relative',
        padding: 10,
        flex: 1,
        textAlign: 'center',
        '@media (min-width: 600px)': {
            width: '100%',
        },
        margin: '0 auto',
    },
    boxImg: {
        maxHeight: 120,
    },
    quiz: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    colorItem: {
        width: '100%',
        height: '100%',
        // minHeight: 99,
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        overflow: 'hidden',
    },
    itemTitle: {
        fontFamily: 'PoppinsRegular',
        margin: 0,
        padding: 0,
        paddingTop: 4,
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: -0.5,
        transition: 'color 0.3s',
        color: theme.palette.primary.light,
    },
}));
